export const SDK_SCRIPT_ID = 'data-collaterate-sdk-site-id';
export const SDK_SCRIPT_DATASET = 'collaterateSdkSiteId';
export const MIN_SITE_ID = 1;
export const S3_SUBMISSION_PROFILE = 'S3_UPLOAD_HTML5';
export const REQUEST_TIMEOUT = 90000;
